import { render, staticRenderFns } from "./FragmentDoFollow.vue?vue&type=template&id=71c7d3a1"
import script from "./FragmentDoFollow.vue?vue&type=script&lang=ts"
export * from "./FragmentDoFollow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports